/*
 *  -----------------------------------------------------------------------
 *    <copyright file="opra-tabs/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import cn from 'clsx';
import React, { useEffect, useState } from 'react';
import { OpraTabsProps } from './opra-tabs.interface';
import './styles.scss';

const OpraTabs = ({ data, className, activeTab, setActiveTab, disableClick }: OpraTabsProps) => {
    const [active, setActive] = useState(0);

    const handleTabChange = (e: TabStripSelectEventArguments) => {
        if (setActiveTab) {
            setActiveTab(e.selected);
        } else if (!disableClick?.value) {
            setActive(e.selected);
        }
    };

    return (
        <TabStrip
            selected={activeTab ?? active}
            onSelect={handleTabChange}
            className={cn('opra-tabs', className)}
            keepTabsMounted
        >
            {data.map(({ tabTitle, tabContent }) => (
                <TabStripTab key={tabTitle} title={tabTitle}>
                    {tabContent}
                </TabStripTab>
            ))}
        </TabStrip>
    );
};

export default OpraTabs;
